import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.76, 0, 0.24, 1];

const CALL_STEPS = [
  "30 minutes, no deck — we ask about your centre or team, you ask us anything",
  "You leave with a written read of your biggest people-risk, whether or not we work together",
  "If there's a fit, a scoped proposal (scope, timeline, price) lands within one business day",
];

/** Closing band driving to the diagnostic-call booking flow. */
export const DiagnosticCta = ({ kicker = "Next step" }) => (
  <section className="py-20 md:py-28 bg-[var(--bg-2)] border-t border-[var(--line-strong)]">
    <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-start">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="md:col-span-7"
      >
        <p className="overline mb-6">{kicker}</p>
        <h2 className="font-display text-3xl sm:text-4xl md:text-6xl tracking-[-0.03em] leading-[0.98] text-[var(--ink)]">
          Book a free{" "}
          <span className="font-serif-accent italic text-[var(--accent)]">
            diagnostic call
          </span>
          .
        </h2>
        <ul className="mt-8 space-y-4 max-w-xl">
          {CALL_STEPS.map((s, i) => (
            <li key={i} className="flex gap-4 items-start">
              <span className="font-serif-accent italic text-[var(--accent)] text-lg leading-none mt-0.5">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-[var(--ink-80)] text-sm md:text-base leading-relaxed">{s}</span>
            </li>
          ))}
        </ul>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
        className="md:col-span-5 flex md:justify-end items-start"
      >
        <Link to="/book-diagnostic" className="btn-pill" data-testid="diagnostic-cta-btn">
          <span>Book a diagnostic call</span>
          <ArrowUpRight className="w-4 h-4" strokeWidth={1.6} />
        </Link>
      </motion.div>
    </div>
  </section>
);

export default DiagnosticCta;
